import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserLocalPersistence,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,    // nuovo
  signInWithPopup       // nuovo
} from 'firebase/auth';
import { 
  getFirestore, 
  collection, 
  getDocs,
  query,
  where,
  doc,
  setDoc,
  writeBatch,
  addDoc
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAE-NPzIqH5bHRr5WKQYnYVA0V_AVURnjI",
  authDomain: "pizzaveg-01.firebaseapp.com",
  projectId: "pizzaveg-01",
  storageBucket: "pizzaveg-01.firebasestorage.app",
  messagingSenderId: "455831397705",
  appId: "1:455831397705:web:778ff5206f183c18bee698"
};



const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// Set persistence to LOCAL
setPersistence(auth, browserLocalPersistence);

interface UserData {
  email: string;
  password: string;
  role: string;
  name: string;
}

export const ensureUserExists = async (userData: UserData) => {
  try {
    // Try to create new user
    const userCredential = await createUserWithEmailAndPassword(auth, userData.email, userData.password);
    
    // Add user to Firestore
    await setDoc(doc(db, 'users', userCredential.user.uid), {
      email: userData.email,
      role: userData.role,
      name: userData.name,
      slices: 0,
      createdAt: new Date().toISOString()
    });

    console.log(`User ${userData.email} created successfully`);
  } catch (error: any) {
    if (error.code === 'auth/email-already-in-use') {
      // User exists, try to update Firestore document
      try {
        const userCredential = await signInWithEmailAndPassword(auth, userData.email, userData.password);
        await setDoc(doc(db, 'users', userCredential.user.uid), {
          email: userData.email,
          role: userData.role,
          name: userData.name,
          updatedAt: new Date().toISOString()
        }, { merge: true });
      } catch (innerError) {
        console.error('Error updating existing user:', innerError);
      }
    } else {
      throw error;
    }
  }
};

export const initializeDatabase = async () => {
  try {
    console.log('Starting database initialization...');
    
    // Initialize collections
    const batch = writeBatch(db);
    const collections = ['pizze', 'pizzerie', 'users', 'pizzeinmenu', 'sliceTransactions'];
    
    for (const collectionName of collections) {
      const collRef = collection(db, collectionName);
      const initDoc = doc(collRef, '_init');
      batch.set(initDoc, {
        initialized: true,
        timestamp: new Date().toISOString()
      });
    }

    await batch.commit();

    // Create indexes for pizzeinmenu collection
    const pizzeinmenuRef = collection(db, 'pizzeinmenu');
    await addDoc(pizzeinmenuRef, {
      _indexConfig: {
        fields: ['pizzeriaId', 'pizzaId', 'addedAt']
      }
    });

    console.log('Database structure initialized successfully');
    return true;
  } catch (error) {
    console.error('Database initialization error:', error);
    throw error;
  }
};